import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { useGetBillingProfile } from '../hooks/use-subscription';
import { BillingDetailsForm } from './billing-details-form';

const sectionTitleClass = 'text-sm font-medium text-muted-foreground sm:text-base';

/** The organization's billing details as they go on the invoice, editable in place. */
export const BillingDetailsSection = () => {
  const { t } = useTranslation();
  const { data: profile, isLoading } = useGetBillingProfile();
  const [editing, setEditing] = useState(false);

  if (isLoading) return null;
  const incomplete = !profile?.isComplete;
  const address = profile?.address;
  const lines = [
    profile?.legalName,
    [profile?.billingContactName, profile?.billingContactEmail].filter(Boolean).join(' · '),
    address &&
      [address.line1, address.postalCode, address.city, address.countryCode]
        .filter(Boolean)
        .join(', '),
    profile?.taxRegistrationId &&
      t('VAT_LINE', { vat: profile.taxRegistrationId, defaultValue: 'VAT {{vat}}' }),
  ].filter(Boolean);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <p className={sectionTitleClass}>{t('BILLING_DETAILS', 'Billing details')}</p>
        {!editing && !incomplete && (
          <Button variant="outline" size="sm" onClick={() => setEditing(true)}>
            {t('EDIT', 'Edit')}
          </Button>
        )}
      </div>
      {editing || incomplete ? (
        <BillingDetailsForm purpose="settings" onSaved={() => setEditing(false)} />
      ) : (
        <div className="space-y-0.5 text-xs text-muted-foreground sm:text-sm">
          {lines.map((line) => (
            <p key={line as string}>{line}</p>
          ))}
        </div>
      )}
    </div>
  );
};
